<template>

    <div class="container-fluid tabs-content">

        <div class="row mb-4">

            <div class="col-24 col-md-12 mb-0 mb-sm-4 mb-md-0">
                <input type="text"
                       class="form-control  form-control-list"
                       placeholder="Sök massör eller mottagning"
                       v-model="settings.query.text"
                >
            </div>

            <div class="col-12 col-md-6 mb-4 mb-md-0 d-none d-sm-flex">
                <datepicker-new
                    input-class="form-control form-control-list"
                    :clear-button="true"
                    clear-button-icon="fa fa-times"
                    placeholder="Från datum"
                    :language="former.datepicker.locale"
                    :use-utc="true"
                    :monday-first="true"
                    :format="formerDateFormat"
                    v-model="settings.query.treatment_at_from"
                />
            </div>

            <div class="col-12 col-md-6 mb-4 mb-md-0 d-none d-sm-flex">
                <datepicker-new
                    input-class="form-control form-control-list"
                    :clear-button="true"
                    clear-button-icon="fa fa-times"
                    placeholder="Till datum"
                    :language="former.datepicker.locale"
                    :use-utc="true"
                    :monday-first="true"
                    :format="formerDateFormat"
                    v-model="settings.query.treatment_at_to"
                />
            </div>

        </div>

        <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
            <div slot="item-row" slot-scope="props">
                <list-item-row :treatment="props.item" :displayFrom="'modal'" />
            </div>
        </list>
    </div>

</template>

<script>
import lister from '../../../shared/mixins/lister'
import former from '../../../shared/mixins/former'

import ListItemRow from '../treatments/list-item-row'

export default {

    mixins: [
        lister,
        former
    ],

    components: {
        ListItemRow
    },

    props: {
        employee: {
            required: true
        }
    },

    data () {
        return {
            settings: {
                url: '/data/employees/' + this.employee.id + '/treatments/list',
                query: {
                    text: '',
                    treatment_at_from: null,
                    treatment_at_to: null
                },
                columns: [
                    { column: 'treatment_at', name: 'Datum', class: 'col-8 col-sm-4 col-lg-3', sortable: true, default: true },
                    { column: 'workplace_title', name: 'Arbetsplats', class: 'col-lg-4 d-none d-lg-flex', sortable: true },
                    { column: 'part_payment', name: 'Delbetalning', class: 'col-sm-5 col-lg-4 d-none d-sm-flex', sortable: false },
                    { column: 'treatment_location', name: 'Beh.plats', class: 'col-12 col-sm-9 col-lg-7', sortable: false },
                    { column: 'buttons', name: 'Massör', class: 'col-lg-5 d-none d-lg-flex', sortable: false }
                ],
                bulk_actions: []
            }
        }
    }
}
</script>
